/**
 * mex-locale-switchers — keeps the language and currency dropdowns from being open at once.
 *
 * The two controls in `snippets/locale-switchers.liquid` are driven by different owners: language is
 * the theme's `<m-select-component>` (assets/theme-global.js), currency is the BUCKS converter app's
 * own widget. Their lists are ~168px and ~265px hanging off pills 8px apart, so both open overlap.
 *
 * Only ONE direction needs help, measured on live rather than assumed:
 *   • clicking the language trigger while the currency list is open — the app closes its own list on
 *     any outside click, so this already works. Nothing here touches it.
 *   • clicking the currency chip while the language list is open — the language list STAYS open. The
 *     app's handler stops propagation, so `MSelectComponent`'s document-level outside-click listener
 *     never fires. That is the gap this file closes, and it listens in the CAPTURE phase for exactly
 *     that reason: a bubble-phase listener would be suppressed the same way.
 *
 * Escape closes whichever is open; neither owner handles it.
 *
 * Closing is done through each owner's own API rather than by editing classes: `closeSelect()` is a
 * method on the theme's custom element, and the app's list is toggled by clicking its chip. Observed
 * app state: `.buckscc-select-styled` carries `active` while open, `active deactive` once closed.
 */
(function () {
  var GROUP = '.mex-locale';
  var CHIP = '.mex-locale__control--currency .buckscc-select-styled';

  function closeLanguage(group) {
    if (!group) return;
    group.querySelectorAll('m-select-component').forEach(function (el) {
      // closeSelect is defined on the theme's custom element; guard in case theme-global.js is absent
      if (typeof el.closeSelect === 'function') el.closeSelect();
      else {
        var custom = el.querySelector('.m-select-custom');
        if (custom) custom.classList.remove('isActive');
      }
    });
  }

  function currencyChipIfOpen(group) {
    var chip = group ? group.querySelector(CHIP) : null;
    if (!chip) return null;
    var open = chip.classList.contains('active') && !chip.classList.contains('deactive');
    return open ? chip : null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var chip = e.target.closest ? e.target.closest(CHIP) : null;
      if (!chip) return;
      closeLanguage(chip.closest(GROUP));
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    document.querySelectorAll(GROUP).forEach(function (group) {
      closeLanguage(group);
      var chip = currencyChipIfOpen(group);
      if (chip) chip.click();
    });
  });
})();
